export async function api(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(data?.message || '请求失败，请稍后重试');
    error.status = response.status;
    error.code = data?.code;
    throw error;
  }
  return data;
}

export function adminApi(path, options = {}) {
  const token = sessionStorage.getItem('adminToken');
  return api(path, {
    ...options,
    headers: { Authorization: `Bearer ${token}`, ...options.headers },
  });
}

export async function downloadAdminExport(type) {
  const token = sessionStorage.getItem('adminToken');
  const response = await fetch(`/api/admin/export?type=${type}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.message || '导出失败');
  }
  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition') || '';
  const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/)?.[1];
  const name = encodedName ? decodeURIComponent(encodedName) : '竞赛数据.xlsx';
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
}
